<a [href]="communicationUrl" target="_blank">

    <icon icon="'pando'" class="-white -hover-pandoblue"></icon>
    <!--
        This comment eliminates whitespace between these nodes and prevents Firefox
        from rendering a linebreak
        --><span *ngIf="unreadMessageCount > 0" class="badge badge-overlay">{{unreadMessageCount}}</span>

</a>
